module.exports = __webpack_public_path__ + "static/media/boshart.b1ad6168.svg";